module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/download.worker.643278900685e6b656bc.js");
}
